import React, { useState } from "react";
import { connect, useIntl, useRouteMatch } from "umi";
import { Layout, Row, Col, } from "tea-component";
import SvgIcon from '@/pages/home/components/SvgIcon';
import ClockContent from './compontnts/ClockContent';
import HeatTable from "@/pages/dashboard/pages/multiTimezone/compontnts/HeatTable";
import NewUsersRetentionFilter from "@/pages/dashboard/filterPageComponents/multiTimezone/newUsersRetentionFilterNew";
import { useBuriedPoint } from "@/pages/home/utils/customHook";
import { FORM_MAP } from '@/pages/dashboard/pages/multiTimezone/_config/constant';
import MarqueeInfo from "@/pages/dashboard/components/MarqueeInfo";

import '@/pages/dashboard/assets/scss/page/multiTimezone/dailyTimezone.scss';
import '@/pages/dashboard/assets/scss/page/multiTimezone/newUserszone.scss';

const { Content } = Layout;
function NewUsersRetention(props: any) {
  const [isHover, setIsHover] = useState(false);

  const { gameCode } = props;
  const { formatMessage } = useIntl();
  const timezoneType = useRouteMatch()?.params.timezonetype;
  // filterValue: null,
  // newFilter: true,
  // timeType: 'Day',
  // [FORM_MAP.RANGE_TIME_DIFF]: true,
  const [formValue, setFormValue] = useState();
  const [filterLoading, setFilterLoading] = useState(true);

  const handleConfirm = (value: any) => {
    setFormValue({
      ...formValue,
      ...value.filterValue,
      [FORM_MAP.IS_INIT]: value.rangeInit
    });
  };
  const handleInit = (value: any) => {
    setFormValue({
      ...formValue,
      ...value.filterValue,
    });
    setFilterLoading(false);
  };
  // 埋点
  const logObj = {
    pageId: timezoneType === "country" ? '201901' : '202101',
    pageName: `multiTimezoneNewUsersRetentionByTimezone${timezoneType === "country" ? "Country" : "Zone"}`,
    extInfo: `multiTimezoneNewUsersRetentionByTimezone${timezoneType === "country" ? "Country" : "Zone"}`,
    pagePath: `/multiTimezone/newUsers/${timezoneType}`,
    uid: props.gameCode,
    typeId: 'dashboard_pc_v2',
  };
  useBuriedPoint(logObj);
  return (
    <Content className='newUserszone-zone dbd-scroll-body'>
      <Content.Header title={
        <div className='dbd-daily-timezone-zone-head'>
          <div className='dbd-daily-timezone-zone-title'>{formatMessage({ id: "new_users_retention_by_timezone_title" })}</div>
          <div className='dbd-daily-timezone-zone-desc'>
            <i className='dbd-daily-timezone-zone-icon-right' onMouseOver={() => { setIsHover(true) }} onMouseOut={() => { setIsHover(false) }}>
              <SvgIcon className='select-header-ic' type={isHover ? 'alert-circle-action' : 'alert-circle-m'} />
            </i>
            <span>{formatMessage({ id: 'new_users_retention_by_timezone_sub_title' })}</span>
          </div>
        </div>
      } />

      <Content.Body full>
        <MarqueeInfo pagePath={`/multiTimezone/newUsers/${timezoneType}`} />
        <Row>
          <Col span={24}>
            <ClockContent
              gameCode={gameCode} filterLoading={filterLoading} timezoneType={timezoneType}
            />
          </Col>
        </Row>

        <Row className="margin-tb">
          <Col span={24}>
            <NewUsersRetentionFilter
              openSticky={true}
              type={timezoneType}
              filterConfirm={handleConfirm}
              filterReset={handleConfirm}
              filterInit={handleInit}
              buttonLogConfig={{
                pageId: logObj?.pageId,
                confirmButtonId: `${logObj?.pageId  }001`,
                resetButtonId: `${logObj?.pageId  }002`
              }}
            />
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <HeatTable gameCode={props.gameCode} formValue={formValue} timezoneType={timezoneType} filterLoading={filterLoading} />
          </Col>
        </Row>
      </Content.Body>
    </Content >
  );
}

export default connect((state: any) => ({
  gameCode: state.dashboard?.currentGame?.game_code,
}))(NewUsersRetention);
